import { render, staticRenderFns } from "./BContentHeader.vue?vue&type=template&id=18dbb910&scoped=true"
import script from "./BContentHeader.vue?vue&type=script&lang=js"
export * from "./BContentHeader.vue?vue&type=script&lang=js"
import style0 from "./BContentHeader.vue?vue&type=style&index=0&id=18dbb910&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dbb910",
  null
  
)

export default component.exports